"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MENU_WIDTH = exports.TOPBAR_MENU_MIN_WIDTH_IN_PX = exports.TOPBAR_DROPDOWN_WIDTH = exports.TOPBAR_HEIGHT = void 0;
var use_context_selector_1 = require("use-context-selector");
exports.TOPBAR_HEIGHT = 64;
exports.TOPBAR_DROPDOWN_WIDTH = 336;
exports.TOPBAR_MENU_MIN_WIDTH_IN_PX = 260;
exports.MENU_WIDTH = 248;
var LayoutContext = (0, use_context_selector_1.createContext)({
    topbar: {
        exists: false,
        register: function () { return function () { return null; }; }
    },
    sidebar: {
        exists: false,
        opened: false,
        register: function () { return function () { return null; }; },
        toogleOpened: function () { return null; },
        trueOpened: function () { return null; },
        falseOpened: function () { return null; }
    },
    userMenu: {
        exists: false,
        opened: false,
        container: null,
        register: function () { return function () { return null; }; },
        registerContainer: function () { return null; },
        toogleOpened: function () { return null; },
        trueOpened: function () { return null; },
        falseOpened: function () { return null; }
    }
});
exports.default = LayoutContext;
